import { useEffect, useState } from "react";
import { Smartphone } from "lucide-react";

// "Add to Home Screen" helper for the admin login page.
// - Android/Chrome: triggers the native install prompt (beforeinstallprompt).
// - iOS Safari: shows the Share → Add to Home Screen instructions.
// Hidden when already running as an installed app.
export function AddToHomeScreen() {
  const [deferred, setDeferred] = useState(null);
  const [isIOS, setIsIOS] = useState(false);
  const [standalone, setStandalone] = useState(false);
  const [showHelp, setShowHelp] = useState(false);

  useEffect(() => {
    const ua = window.navigator.userAgent;
    setIsIOS(/iphone|ipad|ipod/i.test(ua));
    setStandalone(
      window.matchMedia("(display-mode: standalone)").matches ||
      window.navigator.standalone === true
    );
    const handler = (e) => { e.preventDefault(); setDeferred(e); };
    window.addEventListener("beforeinstallprompt", handler);
    return () => window.removeEventListener("beforeinstallprompt", handler);
  }, []);

  if (standalone) return null;

  const onClick = async () => {
    if (deferred) {
      deferred.prompt();
      await deferred.userChoice;
      setDeferred(null);
    } else {
      setShowHelp((v) => !v);
    }
  };

  return (
    <div className="mt-6 text-center border-t border-slate-100 pt-5">
      <button
        type="button"
        onClick={onClick}
        data-testid="add-to-home-button"
        className="inline-flex items-center gap-2 text-brand-blue font-heading font-bold text-sm hover:underline"
      >
        <Smartphone size={16} /> Add to Home Screen
      </button>
      {showHelp && (
        <p data-testid="add-to-home-help" className="text-xs text-slate-500 mt-2 leading-relaxed max-w-xs mx-auto">
          {isIOS ? (
            <>In Safari, tap the <strong>Share</strong> button, then choose <strong>“Add to Home Screen.”</strong> The Nica Moto logo will appear on your phone — tap it anytime to open the admin login.</>
          ) : (
            <>Open your browser menu (⋮) and tap <strong>“Add to Home screen”</strong> or <strong>“Install app.”</strong> Then tap the Nica Moto icon to open the admin login.</>
          )}
        </p>
      )}
    </div>
  );
}

export default AddToHomeScreen;
